import React from 'react'

import { useState , useEffect } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from '@headlessui/react'
import {
    BookmarkIcon,
  DocumentTextIcon,
  FilmIcon,
  RectangleStackIcon,
  UserCircleIcon,
  XMarkIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline'
import logocommon from '../../images/logo_common.png';
import { logout } from '../../services/auth';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Sidebar({ page }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")

  const navigation = [
    { name: 'Topics', href: '/ava-admin/topics', icon: BookmarkIcon, current: page === 'topics' },
    { name: 'Research Papers', href: '/ava-admin/researchpapers', icon: DocumentTextIcon, current: page === 'researchpapers' },
    { name: 'Demos', href: '/ava-admin/demos', icon: FilmIcon, current: page === 'demos' },
    { name: 'Blog Posts', href: '/ava-admin/blogs', icon: RectangleStackIcon, current: page === 'blogs' },
    { name: 'Overview', href: '/ava-admin/overview', icon: Cog6ToothIcon, current: page === 'overview' },
  ]

  useEffect(() => {
    const accountInfo = localStorage.getItem("userName");
  
    if (accountInfo) {
      const userName = accountInfo.split(","); // Removed the second argument, it's not needed
      setLastName(userName[0]);
      setFirstName(userName[1]);
    } else {
      console.warn("No userName found in localStorage.");
    }
  }, []);

  return (
    <>
      <div>
        <div className="w-[300px] h-screen">
          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4 h-screen">
            <div className="flex h-16 shrink-0 items-center">
              <img
                alt="Your Company"
                src={logocommon}
                className="h-8 w-auto mt-3"
              />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          className={classNames(
                            item.current
                              ? 'bg-gray-200 text-gray-800'
                              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800',
                            'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                          )}
                        >
                          <item.icon
                            aria-hidden="true"
                            className={classNames(
                              item.current ? 'text-gray-800' : 'text-gray-700 group-hover:text-gray-800',
                              'size-6 shrink-0',
                            )}
                          />
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto align-middle">
                  <div
                    className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                  >
                    <div className="content-center">
                        <UserCircleIcon
                        aria-hidden="true"
                        className="size-6 shrink-0 text-gray-800"
                        />
                    </div>
                    <div>
                        <div className="text-gray-800">{firstName} {lastName}</div>
                        <div className="text-gray-600 font-normal text-xs cursor-pointer" onClick={()=>{
                          logout()
                        }}>Logout</div>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  )
}
